const getOccurrence = (array, value) => {
    let count = 0
    array.forEach((currentValue) => (currentValue === value && count++))

    return count
}

const isOnlyUniqueItems = (array) => {
    const duplicateItems = array.filter((item, index) => array.indexOf(item) !== index)

    return duplicateItems.length <= 0
}

const getHotkeyChar = (code) => {
    if (code.includes('Key')) {
        return code.slice(3)
    }

    if (code.includes('Digit')) {
        return code.slice(5)
    }

    if (code.includes('Numpad')) {
        const key = code.slice(6)

        if (key.length === 1) {
            return key
        }
    }

    return ''
}

export {getOccurrence, isOnlyUniqueItems, getHotkeyChar}